import { publicApiUrlHandler } from '../src/Shared/Domain/publicApiUrlHandler';
const ConfigurationAdapter = {
  getV4Context(context) {
    const baseUrl = publicApiUrlHandler(context.apiContext.v4);
    return {
      ...context.apiContext.v4,
      baseUrl
    };
  },
  getV5Context(context) {
    return context.apiContext.v5;
  }
};
export default ConfigurationAdapter;
